import { Component, Input } from '@angular/core';
import { CommonService } from '../../services/common.service';

@Component({selector: 'app-chips-with-remained-data',
  templateUrl: './chips-with-remained-data.component.html',
  styleUrls: ['./chips-with-remained-data.component.scss'],
  standalone: false,
})
export class ChipsWithRemainedDataComponent {

  /** Container class */
  @Input() containerClass: string = 'row-inline';

  /** Data array */
  @Input() data: any[];

  /** Show remained data number default is 3 */
  @Input() showRemainedDataNumber: number = 3;

  /** Object key search by default is name */
  @Input() objectKey: string = 'name';

  /** When has value show tooltip on hover chip */
  @Input() tooltipByKey: string;

  constructor(public commonService: CommonService) { }

}
